import MultiManual from "../Manual/MultiManual";

const SearchManual = () => (
    <MultiManual
        components={[
            {
                id: 'input-text-search',
                message: `Você pode buscar uma ocorrência pelo código`,
                padding: 20
            },
            {
                id: 'complaints-filter',
                message: `Você pode usar os filtros que deseja aqui`,
                padding: 20
            },
            {
                id: 'allcomplaints',
                message: `Aqui ficam as ocorrências filtradas aqui`,
                padding: 20
            },
        ]}
    />
)

export default SearchManual;